import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./leaders.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "./../../icon/icon.png";
import { text } from "@fortawesome/fontawesome-svg-core";
import { leaf } from "ionicons/icons";

const Leaders: React.FC = () => {
  const [showProgessBar, setShowProgessBar] = useState(false);
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  const urlParams = new URLSearchParams(window.location.search);
  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    console.log(coffee.test(123));
  }, []);

  var controller = (() => {
    // get all leaders and send the response to getLeader
    function getLeaders(callback) {
      fetch(base_url + "/catalog/categories/system", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_category: 25
        })
      })
        .then((response) => response.json())
        .then((response) => {
          getLeader(callback, response);
        });
    }

    // process in a foreach the getLeaders response
    function getLeader(callback, response) {
      response.items.forEach((element) => {
        fetch(base_url + "/sports/seasons/rankings/category", {
          method: "Post",
          credentials: "omit",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id_category: element.id, //score_id to get all players of that category
            id_season: id_season
          })
        })
          .then((response) => response.json())
          .then((response) => {
            callback(response, element);
          });
      });
    }

    return {
      getLeaders: (callback) => getLeaders(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {};

    function showLeader(response, score) {
      let card_container = document.createElement("div");
      card_container.id = "js__" + score.name;
      card_container.style.display = "none";

      let card_row_col = document.createElement("div");
      card_container.appendChild(card_row_col);

      //card_title
      let card_title = document.createElement("span");
      coffee_tools.createSectionTitle(score.name, card_title);

      card_title.classList.add("ion-text-center", "leaders-table-title");
      card_row_col.appendChild(card_title);

      let all_scores = [];

      let first_score = true;

      response.items.forEach((score) => {
        let table = document.createElement("table");
        let table_row = document.createElement("tr");

        if (first_score) {
          table.classList.add("leaders-table-score-first");
          table.appendChild(table_row);
          card_row_col.classList.add("leader-table-container-first");
          first_score = false;
        } else {
          //card_item

          table.classList.add("leaders-table-score");
          table.appendChild(table_row);
          card_row_col.classList.add("leader-table-container");
        }

        // team logo
        let table_col_1 = document.createElement("td");
        let team_logo = document.createElement("img");
        team_logo.src = base_url + score.team.full_url_logo;
        team_logo.classList.add("leaders-table-score-team-logo");
        table_col_1.appendChild(team_logo);

        let table_col_2 = document.createElement("td");
        // player name
        let player_name = document.createElement("span");
        player_name.classList.add("leaders-table-score-player-data");
        player_name.innerHTML = score.player.name;

        // player position
        let player_position = document.createElement("span");
        player_position.classList.add("leaders-table-score-player-data");
        player_position.innerHTML = score.player.position;

        // player score
        let player_score = document.createElement("span");
        player_score.classList.add("leaders-table-score-player-data");
        player_score.innerHTML = score.points;

        table_col_2.appendChild(player_name);
        table_col_2.appendChild(player_position);
        table_col_2.appendChild(player_score);

        // player picture
        let table_col_5 = document.createElement("td");
        let player_picture = document.createElement("img");
        player_picture.src = base_url + score.player.full_url_image;
        player_picture.classList.add("leaders-table-score-player-picture");
        table_col_5.appendChild(player_picture);

        table_row.appendChild(table_col_1);
        table_row.appendChild(table_col_2);
        table_row.appendChild(table_col_5);

        all_scores.push(table);
      });
      document.getElementById("js__leaders_tables").appendChild(card_container);
      all_scores.forEach((score) => {
        // document.getElementById("js__leaders_tables").appendChild(score);
        card_container.appendChild(score);
      });
      document.getElementById("js__leaders_tables").appendChild(card_container);
    }

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      showLeader: (response, score) => showLeader(response, score),
      dom_obj: dom_obj,
      createSectionTitles: (title, dom_obj_id) =>
        createSectionTitles(title, dom_obj_id)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("leaders started");
        page_view.createSectionTitles(
          "Líderes individuales",
          "js__header_title_leaders_title"
        );
        setupEventListeners();
        document.getElementById("js__leaders_tables").innerHTML = "";
        page_controller.getLeaders(page_view.showLeader);

        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <span id='js__header_title_leaders_title'></span>
        <div style={{ textAlign: "left", backgroundColor: "black" }}>
          <IonSelect
            style={{
              with: "100%",
              display: "inline-block",
              padding: "1rem",
              backgroundColor: "white",
              color: "black"
            }}
            placeholder='Selecciona una categoría'
            onIonChange={(e) => {
              console.log(e.target.value);
              if (e.target.value == 1) {
                document.getElementById("js__Rebotes").style.display = "";
                document.getElementById("js__Puntos").style.display = "none";
                document.getElementById("js__Asistencias").style.display =
                  "none";
              } else if (e.target.value == 2) {
                document.getElementById("js__Puntos").style.display = "";
                document.getElementById("js__Rebotes").style.display = "none";
                document.getElementById("js__Asistencias").style.display =
                  "none";
              } else if (e.target.value == 3) {
                document.getElementById("js__Asistencias").style.display = "";
                document.getElementById("js__Rebotes").style.display = "none";
                document.getElementById("js__Puntos").style.display = "none";
              }
            }}
          >
            <IonSelectOption value='0'>Seleccionar uno</IonSelectOption>

            <IonSelectOption value='1'>Rebotes</IonSelectOption>
            <IonSelectOption value='2'>Puntos</IonSelectOption>
            <IonSelectOption value='3'>Asistencias</IonSelectOption>
          </IonSelect>
        </div>
        <div id='js__leaders_tables'></div>
      </IonContent>
    </IonPage>
  );
};

export default Leaders;
